export const event = {
  0: {
    backgroundColor: "#315E2E",
    image:
      "https://image3.ichuanyi.cn/Files/4d/82/1c/4d821c87cee1509bdc42a5f107a06a5ab5a38a05_194823.jpg",
    title: "ICY首个线下空间登陆上海人广来福士",
    subTitle: "#探索绿洲#",
    linkTitle: "了解更多",
    // linkAddress: "https://mp.weixin.qq.com/s/6qp1DZcSONcni8QIMQpHEQ",
    linkAddress: "2020/0828.html",
    desc: "探索绿洲",
  },
  1: {
    backgroundColor: "#4E4C68",
    image:
      "https://image3.ichuanyi.cn/Files/22/e7/db/22e7dbf8e890911607a7e6368572dcb2e04499b2_208056.png",
    title: "ICY上海环贸IAPM店",
    subTitle: "#绿洲实验 探索新生#",
    linkTitle: "了解更多",
    // linkAddress: "https://mp.weixin.qq.com/s/QRDtL0qVH3aN_vAQUCnhCg",
    linkAddress: "2020/1016.html",
    desc: "绿洲实验 探索新生",
  },
  2: {
    backgroundColor: "#362D28",
    image:
      "https://image3.ichuanyi.cn/Files/71/c7/93/71c7937d0a3e2ae94d58f8199a79ae4c121deadf_172609.jpg",
    title: "ICY X 纽约时装周",
    subTitle: "#吉服回朝#",
    linkTitle: "赋予时装展示无限延伸的可能性",
    // linkAddress: "https://mp.weixin.qq.com/s/yL8Nk2Z0OUAv8qmirPlP-g",
    linkAddress: "2019/0902.html",
    desc: "吉服回朝",
  },
  3: {
    backgroundColor: "#28362D",
    image:
      "https://image3.ichuanyi.cn/Files/e7/0b/41/e70b417da29638c64fa69f9b5774ae0ce1804803_132987.jpg",
    title: "ICY X 数字时装周",
    subTitle: "#进入平行现实#",
    linkTitle: "联动中国设计力量，像世界展现东方美学",
    // linkAddress: "https://mp.weixin.qq.com/s/Ve2oCKjIxRrRNoxXJ8QFnA",
    linkAddress: "2020/0428.html",
    desc: "进入平行现实",
  },
  4: {
    backgroundColor: "#5A2822",
    image:
      "https://image3.ichuanyi.cn/Files/9c/f1/3f/9cf13fe4b17f8c40d7dfac84ff4d09b1a35064db_296163.jpg",
    title: "ICY X 故宫",
    subTitle: "#吉服回潮#",
    linkTitle: "联动中国设计师，引领Z世代焕新经典IP“吉服回潮”",
    // linkAddress: "https://mp.weixin.qq.com/s/fNTY-C3IUC3CuDEs4YC4Dg",
    linkAddress: "2019/0301.html",
    desc: "吉服回潮",
  },
};
